const $ = window.jQuery;
const $window = window.$window || $(window);
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
import '../../../node_modules/swiper/swiper-bundle.min.css'


const SwiperCarousel = {

  init() {
    var $module = $('.swiper-carousel');
    if (!$module.length)
      return;

    $module.each((index, element) => {
      this.each(element);
    });
  },

  each(element) {
    let $item = $(element);
    // Swiper carousel
    function carouselProperties() {
      return new Swiper('.swiper-carousel', {
        autoHeight: true, // enable auto height
        slidesPerView: 1,
        loop: true,
        speed: 500,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="ml-2 h-2 w-2 rounded-full bg-transparent opacity-1 ring-1 ring-white ' + className + '"></span>';
          },
        },

        breakpoints: {
          768: {
            slidesPerView: 1,
          },
        },
        modules: [Navigation, Pagination],
        // Responsive breakpoints
      })
    }
    // if has logomarquee then run script

    // Here we define a variable that returns the swiper
    const carousel = carouselProperties()
    // Afte we define this variable we can finally call the init function
    carousel.init()

  }

};

export default SwiperCarousel;